import React, { useState, useCallback, useEffect } from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
  Table,
  Button,
  TableContainer
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { RobotFont } from "components/ui/RobotFont";
import { IsEmpty, readableFormatDate, toastError } from "shared/utils";
import { KisshtDialog } from "components/custom/KisshtDialog";
import { ViewMapping } from "../dialogs/ViewMapping";
import {
  viewMappingAPi,
  applyPayment,
  lmsMapping,
  markUnpaidApi,
  paymentView,
  verifyPayment,
} from "shared/api";
import { toastSuccess, toastWarning } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import { ROUTES_VAR, ROUTE_NAME, PERMISSIONS } from "shared/constants";
import { Link } from "react-router-dom";
import KisshtButton from "components/ui/KisshtButton";
import { VerifyPayment } from "../dialogs/VerifyPayment";
import { ConfirmDialog } from "components/ui/ConfirmDialog";
import { RefundDialog } from "../dialogs/RefundDialog";
import { ChangeReason } from "../dialogs/ChangeReason";
import Spin from "components/ui/Spin";
import { PaymentReverse } from "../dialogs/PaymentReverse";
import Refund from "./refund";
import { getRefundListing } from 'shared/api';
import { reverseSnoozePayment } from "shared/api/loan";
const changeReason = {
  LOAN_PAYMENT: "LOAN_PAYMENT",
  FORCLOSURE_FEES: "FORCLOSURE_FEES",
  MORATORIUM: "MORATORIUM",
  SNOOZE: "SNOOZE",
  FLIPKART_PAYMENT: "FLIPKART_PAYMENT",
};

const reverseIf = {
  LOAN_PAYMENT: "LOAN_PAYMENT",
  FORCLOSURE_FEES: "FORCLOSURE_FEES",
  SETTLEMENT: "SETTLEMENT",
  DEACTIVATE_LOAN:"DEACTIVATE_LOAN"
};

export const PaymentDetails = ({ Component, data, setData }) => {
  const [spin, setSpin] = useState(false);
  const [verifyPaymentModel, setVerifyPayment] = useState(false);
  const [refundModel, setRefundModel] = useState(false);
  const [changeReasonDialog, setChangeReasonDialog] = useState(false);
  const [markUnpaidDialog, setMarkUnpaidDialog] = useState(false);
  const [mappingReverseDialog, setMappingReverseDialog] = useState(false);
  const [viewMapping, setViewMapping] = useState(false);
  const [viewMappingData, setViewMappingData] = useState([]);
  const [refundData, setrefundData] = useState(null)

  const markUnpaidHandaler = async (e) => {
    e.preventDefault();

    try {
      const res = await markUnpaidApi(data["payment_reference_number"]);
      if (res.success) {
        const payment = await paymentView(data["payment_reference_number"]);
        setData(payment);
        toastSuccess(res.message);
      } else {
        toastWarning(res.message);
      }
    } catch (error) { }
  };

  const viewMappingHandler = (e) => {
    e.preventDefault();
    setSpin(true);
    let apiC =
      data["payment_request_reason"] === "FLIPKART_PAYMENT"
        ? lmsMapping
        : viewMappingAPi;
    apiC(data["payment_reference_number"])
      .then((res) => {
        if (res.success) {
          setViewMappingData(res.data.mapping);
          setViewMapping(true);
        }
        setSpin(false);
      })
      .catch((errer) => {
        setSpin(false);
      });
  };
  const applyPaymentHandler = (e) => {
    e.preventDefault();
    setSpin(true);
    applyPayment(data["payment_reference_number"])
      .then((res) => {
        if (res.success) {
          toastSuccess(res.message);
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        } else {
          toastWarning(res.message);
        }
        setSpin(false);
      })
      .catch((error) => {
        setSpin(false);
      });
  };

  const handleVerifyPaymentCallback = useCallback((sts) => {
    if (sts) {
      window.location.reload();
    }
    setVerifyPayment(false);
  },[]);
  
  const handleRefundPaymentCallback = useCallback((sts) => {
    if (sts) {
      window.location.reload();
    }
    setRefundModel(false);
  },[]);

  const snoozeReverseHandler = (_) => {
    let param = {
      user_reference_number: data['user_reference_number'],
      payment_reference_number: data["payment_reference_number"],
      payment_request_reason: 'SNOOZE'
    }
    setSpin(true);
    reverseSnoozePayment(param).then(async res => {
      if (res && res.success) {
        const payment = await paymentView(data["payment_reference_number"]);
        setSpin(false);
        setData(payment);
        toastSuccess(res.message);
      }
    }, err => {
      setSpin(false);
    }).catch(err => {
      setSpin(false);
      toastError(err.message)
    })
  }

  useEffect(() => {
    if (data['payment_status'] === "REFUNDED" || data['refunded_amount'] > 0) {
      let param = `?payment_reference_number=${data['payment_reference_number']}`
      getRefundListing(param).then(res => {
        if (res && res.data && Object.keys(res.data).length > 0) {
          setrefundData(res.data.refunds);
        }
      }, err => {
        setrefundData(null)
      })
    }
    // eslint-disable-next-line
  }, [])


  return (
    <Spin spinning={spin}>
      <Card>
        <CardContent className="card-content_head">
          <Grid container alignItems="center">
            <Grid item lg={3} md={3} sm={4} xs={8}>
              Payment Details
            </Grid>
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button
                    variant="contained"
                    className="shadow-none common_kissht_btn"
                    color="primary"
                    onClick={viewMappingHandler}
                  >
                    View Mapping
                  </Button>
                </Grid>
                {data["payment_status"] === "PAID" ? (
                  <Grid item>
                    <KisshtButton
                      onClick={applyPaymentHandler}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.apply_payment}
                      className="common_kissht_btn"
                    >
                      Apply Payment
                    </KisshtButton>
                  </Grid>
                ) : null}

                {data["payment_request_reason"] &&
                  data["payment_status"] === "PAID" &&
                  changeReason[data["payment_request_reason"]] ? (
                  <Grid item>
                    <KisshtButton
                      onClick={(e) => setChangeReasonDialog(true)}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.change_payment_reason}
                      className="common_kissht_btn"
                    >
                      Change Reason
                    </KisshtButton>
                  </Grid>
                ) : null}

                {data["payment_status"] === "PAID" ? (
                  <Grid item>
                    <KisshtButton
                      onClick={() => setMarkUnpaidDialog(true)}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.mark_unpaid}
                      className="common_kissht_btn"
                    >
                      Mark Unpaid
                    </KisshtButton>
                  </Grid>
                ) : null}
                {data["payment_status"] === "PAID" &&
                  reverseIf[data["payment_request_reason"]] ? (
                  <Grid item>
                    <KisshtButton
                      disabled={(data["extra_payment_amount"] === data["payment_amount"]) ? "disable": false}
                      onClick={() => setMappingReverseDialog(true)}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.mapping_reverse}
                      className="common_kissht_btn"
                    >
                      Mapping Reverse
                    </KisshtButton>
                  </Grid>
                ) : null}
                {data["payment_status"] === "PAID" &&
                  data["payment_request_reason"] === "SNOOZE" ? (
                  <Grid item>
                    <KisshtButton
                      onClick={() => snoozeReverseHandler()}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.mark_unpaid}
                      className="common_kissht_btn"
                    >
                      Snooze Reverse
                    </KisshtButton>
                  </Grid>
                ) : null}
                {data["payment_status"] === "NOT_PAID" ||
                  data["payment_status"] === "CANCELLED" ||
                  data["payment_status"] === "PROCESSING" ? (
                  <Grid item>
                    <KisshtButton
                      onClick={() => setVerifyPayment(true)}
                      route={ROUTE_NAME.payment}
                      permission={PERMISSIONS.payment.verify_payment}
                      className="common_kissht_btn"
                    >
                      Verify Payment
                    </KisshtButton>
                  </Grid>
                ) : null}
                {data["payment_receipt_mode"] !== "PROMOTIONAL" &&
                  data["payment_receipt_mode"] !== "CASH_PAID_STORE" &&
                  data["extra_payment_amount"] > 0 && (data["payment_status"] === "PAID"
                  || data["payment_status"] === 'REFUNDED') &&
                    <Grid item>
                      <KisshtButton
                        onClick={(e) => setRefundModel(true)}
                        route={ROUTE_NAME.payment}
                        permission={PERMISSIONS.payment.refund_view}
                        className="common_kissht_btn"
                      >
                        Refund
                      </KisshtButton>
                    </Grid>
                  }
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <CustomTableWrapper>
            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <Table className="w-full">
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Customer Name</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["user_name"]}</TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Reference Number</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["payment_reference_number"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">User Reference Number</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <Link
                        target="_blank"
                        to={`${ROUTES_VAR.users}/${data["user_reference_number"]}`}
                        style={{ color: "#6098F1" }}
                      >
                        {data["user_reference_number"]}
                      </Link>
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">
                      Source / Source Reference Number
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {`${data["source"] ? data["source"] : "-"} / ${data["source_reference_number"]
                        ? data["source_reference_number"]
                        : "-"
                        }`}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Initiate Source</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <IsEmpty itemKey={data} value="payment_initiate_source" />
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Reason</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["payment_request_reason"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Receipt Mode / Source</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {`${data["payment_receipt_mode"]} / ${data["payment_receipt_source"]
                        ? data["payment_receipt_source"]
                        : "-"
                        }`}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Status</TableBodyCell>
                    <TableBodyCell>
                      <BootstrapBadge text={data["payment_status"]} />
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Receipt Date</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["payment_receipt_date"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
              </Table>
              </TableContainer> 
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <table className="w-full">
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Amount</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">₹</RobotFont>
                      {data["payment_amount"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell style={{ whiteSpace: "nowrap" }} className="common_table_title">
                      Surcharge Amount
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">₹</RobotFont>
                      {data["surcharge_amount"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Extra Amount</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">₹</RobotFont>
                      {data["extra_payment_amount"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Refunded Amount</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <RobotFont type="medium">₹</RobotFont>
                      {data["refunded_amount"]}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Added By Subuser</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["added_by_subuser_name"]}</TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Initiate Source</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["payment_initiate_source"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {readableFormatDate(data["created_at"])}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Updated Date</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {readableFormatDate(data["updated_at"])}
                    </TableBodyCell>
                  </TableRow>
                </TableBody>
              </table>
              </TableContainer>  
            </Grid>
          </CustomTableWrapper>
        </CardContent>
      </Card>


      {data["payment_receipt_mode_data"] && (
        <Component
          data={data["payment_receipt_mode_data"]}
          payment_ref_no={data["payment_reference_number"]}
          setSpin={setSpin}
        />
      )}
      {refundData && <Refund data={refundData}></Refund>}
      <KisshtDialog
        title="Mappings"
        maxWidth="lg"
        open={viewMapping}
        handleClose={() => setViewMapping(false)}
      >
        <ViewMapping
          data={viewMappingData}
          reason={data["payment_request_reason"]}
        />
      </KisshtDialog>
      <KisshtDialog
        // maxWidth="sm"
        title="Verify Payment"
        open={verifyPaymentModel}
        handleClose={handleVerifyPaymentCallback}
      >
        <VerifyPayment api={verifyPayment} handleClose={handleVerifyPaymentCallback} paymentRef={data['payment_reference_number']} paymentMode={data['payment_receipt_mode']} />
      </KisshtDialog>
      <KisshtDialog
        // maxWidth="sm"
        title="Change Reason"
        open={changeReasonDialog}
        handleClose={(e) => setChangeReasonDialog(false)}
      >
        <ChangeReason
          handleClose={(e) => setChangeReasonDialog(false)}
          data={data}
        />
      </KisshtDialog>
      <KisshtDialog
        // maxWidth="sm"
        title={`Apply Refund (${data["payment_reference_number"]})`}
        open={refundModel}
        handleClose={useCallback(() => setRefundModel(false),[])}
      >
        <RefundDialog handleClose={handleRefundPaymentCallback} data={data} />
      </KisshtDialog>
      <KisshtDialog
        // maxWidth="sm"
        title={`Payment Reverse`}
        open={mappingReverseDialog}
        handleClose={setMappingReverseDialog}
      >
        <PaymentReverse handleClose={setMappingReverseDialog} data={data} />
      </KisshtDialog>
      <ConfirmDialog
        open={markUnpaidDialog}
        handleClose={(e) => setMarkUnpaidDialog(false)}
        titleColor="red"
        title="Warning"
        message="Once you change the payment to unpaid, you can't change it back."
        onAccept={markUnpaidHandaler}
      />
    </Spin>
  );
};
